import { STitle } from 'shj-components'
import { FormOutlined } from '@ant-design/icons'
import styles from '@/pages/saleOperations/saleWorkBench/customerDetail/index.module.less'
import classNames from 'classnames'
import AddNewPlanModal from '@/components/AddNewPlanModal'
import React, { useContext } from 'react'
import { useSetState } from 'ahooks'
import ClueDetailContext from '@/pages/clueManage/clueDetail/clueDetailContext.ts'
import dayjs from 'dayjs'
import { getAuth } from '@/utils/auth.ts'

const BuildInfo = () => {
  const { detailState, updateDetail, viewPhoneKey, editPhoneKey, editCustomerChannelKey, editKey } =
    useContext(ClueDetailContext)
  const auth = getAuth()

  const [state, setState] = useSetState<any>({
    open: false,
  })

  const onEditUserInfo = () => {
    setState({ open: true })
  }

  return (
    <div>
      <div
        className={classNames([styles.flexBetweenStart, styles.mb20])}
        style={{ alignItems: 'center' }}
      >
        <STitle title={'楼盘信息'} />
        {detailState.isPublicSea
          ? null
          : auth[editKey] && <FormOutlined onClick={onEditUserInfo} />}
      </div>
      <div>
        <p className={styles.mb20}>
          <span className={styles.label}>客户来源：</span>
          <span className={styles.value}>{detailState?.houseInfo?.channelName}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>门店：</span>
          <span className={styles.value}>{detailState?.houseInfo?.orgName}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>楼盘：</span>
          <span className={styles.value}>{detailState?.houseInfo?.buildingName}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>门牌号：</span>
          <span className={styles.value}>{detailState?.houseInfo?.doorNo}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>房屋属性：</span>
          <span className={styles.value}>{detailState?.houseInfo?.houseNatureName}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>房屋状态：</span>
          <span className={styles.value}>{detailState?.houseInfo?.houseStatusName}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>房屋类型：</span>
          <span className={styles.value}>{detailState?.houseInfo?.houseKindName}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>户型：</span>
          <span className={styles.value}>{detailState?.houseInfo?.layoutName}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>建筑面积：</span>
          <span className={styles.value}>{detailState?.houseInfo?.constructArea}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>套内面积：</span>
          <span className={styles.value}>{detailState?.houseInfo?.innerArea}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>层高：</span>
          <span className={styles.value}>{detailState?.houseInfo?.houseHight}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>交房日期：</span>
          <span className={styles.value}>
            {detailState?.houseInfo?.handoverDate
              ? dayjs(detailState?.houseInfo?.handoverDate).format('YYYY-MM-DD')
              : ''}
          </span>
        </p>
      </div>
      <STitle title={'家空间需求'} style={{ marginBottom: 20 }} />
      <div>
        <p className={styles.mb20}>
          <span className={styles.label}>需求标签：</span>
          <span className={styles.value}>{detailState?.dtlInfo?.bizTypeNames}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>装修预算：</span>
          <span className={styles.value}>{detailState?.dtlInfo?.budgetName}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>装修风格：</span>
          <span className={styles.value}>{detailState?.dtlInfo?.designStyleName}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>居住目的：</span>
          <span className={styles.value}>{detailState?.dtlInfo?.livePurposeName}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>常住人口：</span>
          <span className={styles.value}>{detailState?.dtlInfo?.permanentResidentsName}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>孩子性别：</span>
          <span className={styles.value}>{detailState?.dtlInfo?.childGender || '-'}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>孩子年龄：</span>
          <span className={styles.value}>{detailState?.dtlInfo?.childAgeName || '-'}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>宠物：</span>
          <span className={styles.value}>{detailState?.dtlInfo?.petsName || '-'}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>宠物备注：</span>
          <span className={styles.value}>{detailState?.dtlInfo?.petsOther || '-'}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>竞品公司：</span>
          <span className={styles.value}>{detailState?.dtlInfo?.competitorCompanyName || '-'}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>户型改造需求：</span>
          <span className={styles.value}>{detailState?.dtlInfo?.renovationDemandName || '-'}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>户型改造需求备注：</span>
          <span className={styles.value}>{detailState?.dtlInfo?.renovationDemandOther || '-'}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>签单意向：</span>
          <span className={styles.value}>{detailState?.dtlInfo?.signIntentionName}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>产品意向：</span>
          <span className={styles.value}>{detailState?.dtlInfo?.intentionProductName}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>功能需求：</span>
          <span className={styles.value}>{detailState?.dtlInfo?.houseDemandName}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>预计进场装修时间：</span>
          <span className={styles.value}>
            {detailState?.dtlInfo?.expectRenovationDate
              ? dayjs(detailState?.dtlInfo?.expectRenovationDate).format('YYYY-MM-DD')
              : ''}
          </span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>预计定装修时间：</span>
          <span className={styles.value}>
            {detailState?.dtlInfo?.estimatedRenovationTime
              ? dayjs(detailState?.dtlInfo?.estimatedRenovationTime).format('YYYY-MM-DD')
              : ''}
          </span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>期待入住时间：</span>
          <span className={styles.value}>
            {detailState?.dtlInfo?.lookingForwardToStayingTime
              ? dayjs(detailState?.dtlInfo?.lookingForwardToStayingTime).format(
                  'YYYY-MM-DD HH:mm:ss'
                )
              : ''}
          </span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>痛点：</span>
          <span className={styles.value}>{detailState?.dtlInfo?.painPointName}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>痛点备注：</span>
          <span className={styles.value}>{detailState?.dtlInfo?.painPointRemark || '-'}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>痒点：</span>
          <span className={styles.value}>{detailState?.dtlInfo?.itchPointName}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>痒点备注：</span>
          <span className={styles.value}>{detailState?.dtlInfo?.itchPointRemark || '-'}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>障碍点：</span>
          <span className={styles.value}>{detailState?.dtlInfo?.blockPointName}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>障碍点备注：</span>
          <span className={styles.value}>{detailState?.dtlInfo?.blockPointRemark || '-'}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>爆破点：</span>
          <span className={styles.value}>{detailState?.dtlInfo?.breakPointName}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>爆破点备注：</span>
          <span className={styles.value}>{detailState?.dtlInfo?.breakPointRemark || '-'}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>备注：</span>
          <span className={styles.value}>{detailState?.dtlInfo?.remark}</span>
        </p>
      </div>
      <STitle title={'来源信息'} style={{ marginBottom: 20 }} />
      <div>
        <p className={styles.mb20}>
          <span className={styles.label}>军种：</span>
          <span className={styles.value}>{detailState?.channelClue?.channelTypeName}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>军种总分归属：</span>
          <span className={styles.value}>{detailState?.channelClue?.armyAffiliationName}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>品牌：</span>
          <span className={styles.value}>{detailState?.channelClue?.brandName}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>报名城市：</span>
          <span className={styles.value}>{detailState?.channelClue?.cityName}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>线索账号：</span>
          <span className={styles.value}>{detailState?.channelClue?.accountName}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>广告计划：</span>
          <span className={styles.value}>{detailState?.channelClue?.plan}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>报名页面：</span>
          <span className={styles.value}>{detailState?.channelClue?.applyPage}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>报名页说明：</span>
          <span className={styles.value}>{detailState?.channelClue?.applyPageDesc}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>报名时间：</span>
          <span className={styles.value}>
            {detailState?.channelClue?.signUpTime &&
              dayjs(detailState?.channelClue?.signUpTime).format('YYYY-MM-DD HH:mm:ss')}
          </span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>报名URL：</span>
          <span className={styles.value}>{detailState?.channelClue?.applyUrl}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>着陆URL：</span>
          <span className={styles.value}>{detailState?.channelClue?.landPageUrl}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>搜索用词：</span>
          <span className={styles.value}>{detailState?.channelClue?.searchWord}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>信息流广告视频：</span>
          <span className={styles.value}>{detailState?.channelClue?.creativeVideo}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>天猫订单号：</span>
          <span className={styles.value}>{detailState?.channelClue?.aliOrderNumber}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>加微时间：</span>
          <span className={styles.value}>
            {detailState?.channelClue?.salesAddQvTime &&
              dayjs(detailState?.channelClue?.salesAddQvTime).format('YYYY-MM-DD HH:mm:ss')}
          </span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>推荐官手机号：</span>
          <span className={styles.value}>{detailState?.channelClue?.broker}</span>
        </p>
        <p className={styles.mb20}>
          <span className={styles.label}>推荐官门店：</span>
          <span className={styles.value}>{detailState?.channelClue?.brokerStore}</span>
        </p>
      </div>
      {state.open && (
        <AddNewPlanModal
          basicInfo={detailState}
          viewPhoneKey={viewPhoneKey}
          editPhoneKey={editPhoneKey}
          editCustomerChannelKey={editCustomerChannelKey}
          editReload={() => {}}
          reload={() => updateDetail({ isReload: !detailState.isReload })}
          isEdit={true}
          open={state.open}
          onClose={() => setState({ open: false })}
        />
      )}
    </div>
  )
}

export default BuildInfo
